export const CREATE_REMIX_REQUEST = 'CREATE_REMIX_REQUEST';
export const CREATE_REMIX_SUCCESS = 'CREATE_REMIX_SUCCESS';
export const CREATE_REMIX_FAILURE = 'CREATE_REMIX_FAILURE';